import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/products/sms/rates`,
            data: {
                data: [],
                metadata: []
            },
            onclick: 'link',
            link: '/products/sms/rates/{id}',
            userFilterSimple: true,
            userFilterExpandable: false,
            userfilter:
                [
                    {
                        source: 'ATRNAME',
                        label: 'Name',
                        type: 'text'
                    }
                ],
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSMSRATEID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Rate Table Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New Rate table...'
                    },
                    {
                        'label': 'Description',
                        'source': 'description',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Delete',
                        'source': 'ATRSMSRATEID',
                        'type': 'delete',
                        'visible': true
                    }
                ]
        }
        return (
            <Panel title = "SMS Rate Tables">
                <DataResource
                    addButtonText = "Create SMS Rate Table"  
                    addButtonLink = "/products/sms/rates/create"                  
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
